import React from 'react'

const About = () => {
  return (
    <div name="About"
     className='w-full h-screen  bg-gradient-to-b from-gray-800 to-black text-white' >
      <div className='flex p-4 flex-col max-w-screen-lg justify-center mx-auto w-full h-full '>
        <div className='pb-8'>
            <p className='text-4xl font-bold border-b-4 inline border-gray-500'>About</p>
        </div>
        <p className='text-xl mt-20'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium ullam unde temporibus provident, quisquam molestiae placeat ipsa vero eaque aut eius accusantium, modi inventore et tenetur maiores assumenda, aliquam alias quas perferendis. Dolor est aliquam ipsam! Autem, itaque? Laborum numquam repudiandae totam nam, ipsa similique dolor fugiat reiciendis error tenetur.</p>
                  <br />
        <p className='text-xl'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam, itaque, fugiat voluptatibus dolores, repellat aspernatur modi odit repellendus fuga at dolore. Commodi excepturi voluptates earum, facilis quae doloribus ipsum ratione, dignissimos nisi at vitae obcaecati dicta eum? Nulla unde deleniti sunt voluptate facere, repellat, saepe eum omnis dolorum labore minus!</p>          
      </div>
    </div>
  )
}

export default About